
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  emits: ["close"],
}) class NoteInfo extends Vue {
  @Prop({ required: false }) public text!: string;
  @Prop({ required: false, default: true }) public showCloseButton = true;
  @Prop({ required: false, default: "#D9EDE2" })
  public backgroundColor!: string;
}

const __default__ = NoteInfo
import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "7d567236": (_ctx.backgroundColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__